module.exports = __webpack_public_path__ + "img/receive-coupon.2a22da7a.png";